var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg6X(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "00 00 75 75",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00933C",
    d: "M2.87 37.45 37.45 2.87l34.58 34.58-34.58 34.58z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.109 30.07c-.16-1.6-1.2-2.72-3.28-2.72-3.64 0-4.48 4.16-4.68 7.84l.08.08c.76-1.04 2.16-2.36 5.32-2.36 5.88 0 8.681 4.52 8.681 8.76 0 6.199-3.801 10.359-9.28 10.359-8.6 0-10.28-7.2-10.28-14.279 0-5.4.72-14.88 10.56-14.88 1.161 0 4.4.44 5.8 1.84 1.56 1.52 2.12 2.36 2.64 5.36h-5.561zm-3.56 7.32c-2.12 0-4.28 1.32-4.28 4.88 0 3.08 1.76 5.28 4.44 5.28 2.04 0 3.92-1.561 3.92-5.4-.001-3.6-2.32-4.76-4.08-4.76z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6X);
export default __webpack_public_path__ + "static/media/6x.2c49806a903ce127e7e3652688aa0f45.svg";
export { ForwardRef as ReactComponent };